import {
  ADMIN_PERSONAL_INFO_FAIL,
  ADMIN_PERSONAL_INFO_REQUEST,
  ADMIN_PERSONAL_INFO_SUCCESS,
  GET_ADMIN_PERSONAL_INFO_FAIL,
  GET_ADMIN_PERSONAL_INFO_REQUEST,
  GET_ADMIN_PERSONAL_INFO_SUCCESS,
} from "../../types/admin/personalInfoTypes";

export const adminPersonalReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADMIN_PERSONAL_INFO_REQUEST:
      return {
        ...state,
        personalAdminLoading: true,
      };
    case ADMIN_PERSONAL_INFO_SUCCESS:
      return {
        ...state,
        personalAdminLoading: false,
        AdminPersonalInfo: payload,
        personalAdminError: "",
      };
    case ADMIN_PERSONAL_INFO_FAIL:
      return {
        ...state,
        personalAdminLoading: false,
        AdminPersonalInfo: [],
        personalAdminError: payload,
      };
    default:
      return state;
  }
};

export const getAdminPersonalReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ADMIN_PERSONAL_INFO_REQUEST:
      return {
        ...state,
        getPersonalAdminLoading: true,
      };
    case GET_ADMIN_PERSONAL_INFO_SUCCESS:
      return {
        ...state,
        getPersonalAdminLoading: false,
        getAdminPersonalInfo: payload,
        getPersonalAdminError: "",
      };
    case GET_ADMIN_PERSONAL_INFO_FAIL:
      return {
        ...state,
        getPersonalAdminLoading: false,
        getAdminPersonalInfo: [],
        getPersonalAdminError: payload,
      };
    default:
      return state;
  }
};
